import React from "react";
import { Badge, Card, Col, Form, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { useParams, useRouteLoaderData } from "react-router-dom";

import { useAppApi } from "@/App";
import { useRequest } from "@components/AppHook";
import { DevForm } from "@components/Forms/Fields";
import { buildFormData } from "@components/Forms/Handlers";
import RenderErrors from "@components/Pages";
import { linkify, url_reverse } from "@components/Utils";

export default function FeaturingNewsletter({ header }) {
    const { t } = useTranslation();
    const { event_slug, newsletter_id, gameId } = useParams();
    const { apiData, setApiData, apiUrl } = useAppApi(
        url_reverse("api:event:newsletter", { event_slug, newsletter_id, game_id: gameId })
    );
    const { api_post_formdata } = useRequest();
    const submitPrefixes = Object.keys(apiData?.forms_data || {});
    const gameCommonInfo = useRouteLoaderData("gameCommonInfo");
    const commonInfo = useRouteLoaderData("commonInfo");

    if (!apiData) return;

    const onSubmit = (ev) => {
        ev.preventDefault();
        api_post_formdata(ev, apiUrl, buildFormData({ ev, apiData, submitPrefixes: ["main"] }), {
            then: (resp) => {
                if (resp.status === "ok") {
                    setApiData(resp);
                } else if (resp.forms_data) {
                    // костыль для файловых полей
                    for (const prefix of submitPrefixes) {
                        const form = apiData.forms_data[prefix];
                        for (const [name, field] of Object.entries(form.fields)) {
                            const cur_val = form.data[name];
                            if (field.widget.input_type === "file" && cur_val) {
                                resp.forms_data[form.prefix].data[name] = cur_val;
                            }
                        }
                    }
                    setApiData(resp);
                }
            },
        });
    };

    const newsLetterType = {
        possible_participant: "possible_participant",
        new_participant: "new_participant",
    };

    const dataModerationState = {
        accepted: t("Одобрен"),
        rejected: t("Отклонен"),
        check: t("Проверка"),
        request: t("Запрос"),
    };
    const moderationState = {
        MATERIAL_REQUEST: "material_request",
        MARKETING_REVIEW: "marketing_review",
        MATERIAL_REJECTED: "material_rejected",
        REVIEW_PASSED: "review_passed",
    };
    const buttonDisabled =
        apiData?.moderation_state === moderationState.MARKETING_REVIEW ||
        apiData?.status === "error" ||
        apiData?.event?.is_application_collection_closed & !commonInfo.account.is_super;

    const budgeVariant = (el) => {
        const type = dataModerationState[apiData.data_moderation_state[el]];
        switch (type) {
            case dataModerationState.accepted:
                return "success";
            case dataModerationState.rejected:
                return "danger";
            case dataModerationState.check:
                return "info";
            case dataModerationState.request:
                return "secondary";
        }
    };

    return (
        <Card>
            <Card.Header>{header}</Card.Header>
            <Card.Body>
                <RenderErrors apiData={apiData} />
                {apiData?.status === "error" && apiData?.newsletter?.type === newsLetterType.new_participant && (
                    <div className="dmg-callout dmg-callout-danger mb-3">
                        <div dangerouslySetInnerHTML={{ __html: apiData.error_message }} />
                    </div>
                )}
                {apiData.is_warning &&
                    apiData?.status === "ok" &&
                    apiData?.newsletter?.type === newsLetterType.new_participant && (
                        <div className="dmg-callout dmg-callout-warning mb-3">
                            <div dangerouslySetInnerHTML={{ __html: apiData.warning_message }} />
                        </div>
                    )}
                {apiData?.moderation_state === moderationState.MARKETING_REVIEW && (
                    <div className="dmg-callout dmg-callout-info mb-3">{t("Данные находятся на модерации")}</div>
                )}
                {apiData?.event?.is_application_collection_closed && (
                    <div className="dmg-callout dmg-callout-info mb-3">
                        <Trans>Внимание-внимание!</Trans>
                        <br />
                        <br />
                        <Trans>
                            Срок подачи заявок завершен, список участников сформирован. Тех, кто не успел оставить
                            заявку, будем ждать на следующих мероприятиях.
                        </Trans>
                        <br />
                        <br />
                        <Trans>
                            Следите за обновлениями площадки в{" "}
                            <a href="https://vk.com/play" target="_blank">
                                группе ВК
                            </a>{" "}
                            и{" "}
                        </Trans>
                        <Trans>
                            <a href="https://t.me/vkplaydevelopers" target="_blank">
                                ТГ-канале
                            </a>
                        </Trans>
                    </div>
                )}
                {apiData?.moderation_state === moderationState.REVIEW_PASSED && (
                    <div className="dmg-callout dmg-callout-success mb-3">
                        {apiData?.requested_fields_length > 0 && (
                            <Trans event={apiData?.event?.name}>
                                Материалы успешно прошли модерацию. Ваша заявка на участие в ивенте{" "}
                                {{ event: apiData?.event?.name }} принята. Благодарим за участие!
                            </Trans>
                        )}
                        {apiData?.requested_fields_length === 0 && (
                            <Trans event={apiData?.event?.name}>
                                Ваша заявка на участие в ивенте {{ event: apiData?.event?.name }} принята. Благодарим за
                                участие!
                            </Trans>
                        )}
                    </div>
                )}
                {apiData?.moderation_state === moderationState.MATERIAL_REJECTED && (
                    <div className="dmg-callout dmg-callout-danger mb-3">
                        {t(
                            "Модератор нашел ошибку в материалах. Исправьте ошибку и отправьте материалы еще раз на модерацию."
                        )}
                    </div>
                )}
                <Card style={{ marginBottom: "10px" }}>
                    <Card.Body>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: linkify(
                                    gameCommonInfo.developer.contact_lang === "rus"
                                        ? apiData?.newsletter?.event_description
                                        : apiData?.newsletter?.event_description_en
                                ),
                            }}
                        />
                    </Card.Body>
                </Card>
                {apiData?.newsletter?.type === newsLetterType.new_participant &&
                    !(
                        apiData?.requested_fields_length === 0 &&
                        apiData?.moderation_state === moderationState.REVIEW_PASSED
                    ) && (
                        <Card>
                            <Card.Body>
                                <Form onSubmit={onSubmit}>
                                    {Object.entries(apiData?.forms_data?.main?.fields || {}).map(([el, value]) => {
                                        if (el === "game_id") {
                                            return null;
                                        }
                                        return (
                                            <Row className="mb-2" key={el}>
                                                <Col md={10}>
                                                    <DevForm.Field
                                                        prefix="main"
                                                        name={el}
                                                        hideInputs={value.widget?.attrs?.hide_inputs}
                                                    />
                                                </Col>
                                                <Col md={2} className="mt-1">
                                                    <Badge variant={budgeVariant(el)}>
                                                        {dataModerationState[apiData.data_moderation_state[el]]}
                                                    </Badge>
                                                </Col>
                                            </Row>
                                        );
                                    })}
                                    {apiData?.moderation_state !== moderationState.REVIEW_PASSED && (
                                        <DevForm.Button
                                            variant="primary"
                                            type="submit"
                                            name="submit"
                                            disabled={buttonDisabled}
                                        >
                                            {apiData?.moderation_state === moderationState.MATERIAL_REJECTED
                                                ? t("Отправить на проверку")
                                                : t("Принять участие")}
                                        </DevForm.Button>
                                    )}
                                </Form>
                            </Card.Body>
                        </Card>
                    )}
            </Card.Body>
        </Card>
    );
}
